import { cn } from '@/lib/utils'
import { SUPPORT_EMAIL_OTP_LEN } from '@/hooks/useSupportEmailVerification'

export interface OtpCodeInputProps {
  length?: number
  digits: string[]
  disabled?: boolean
  inputRefs: React.MutableRefObject<(HTMLInputElement | null)[]>
  onChange: (index: number, e: React.ChangeEvent<HTMLInputElement>) => void
  onKeyDown: (index: number, e: React.KeyboardEvent<HTMLInputElement>) => void
  onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => void
  ariaLabel: string
  dataCyPrefix?: string
  className?: string
}

export function OtpCodeInput({
  length = SUPPORT_EMAIL_OTP_LEN,
  digits,
  disabled = false,
  inputRefs,
  onChange,
  onKeyDown,
  onPaste,
  ariaLabel,
  dataCyPrefix = 'otp',
  className,
}: OtpCodeInputProps) {
  return (
    <div
      className={cn('mt-4 flex flex-col items-center gap-2', className)}
      role="group"
      aria-label={ariaLabel}
    >
      <div className="flex justify-center gap-2 sm:gap-3">
        {Array.from({ length }, (_, i) => (
          <input
            key={i}
            ref={(el) => {
              inputRefs.current[i] = el
            }}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            autoComplete="one-time-code"
            maxLength={length}
            value={digits[i] ?? ''}
            onChange={(e) => onChange(i, e)}
            onKeyDown={(e) => onKeyDown(i, e)}
            onPaste={onPaste}
            disabled={disabled}
            data-cy={`${dataCyPrefix}-${i}`}
            aria-label={`${ariaLabel} ${i + 1}/${length}`}
            className={cn(
              'h-12 w-10 sm:h-14 sm:w-12 rounded-md border bg-transparent text-center text-xl font-mono tabular-nums outline-none transition-colors sm:text-2xl',
              'border-colorBorder focus-visible:border-lime-500/60 focus-visible:ring-1 focus-visible:ring-lime-500/30',
              disabled && 'cursor-not-allowed opacity-50',
            )}
          />
        ))}
      </div>
    </div>
  )
}
